import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, onMounted } from "vue";
import { Shozoku } from "@/models/transaction/Shozoku";

type Props = {
  value?: number;
  label?: string;
  autoSelectFirst?: boolean;
  init?: boolean;
  path?: string;
  code?: boolean;
};
type Emits = {
  (e: "input", val?: number): void;
};

import { useApi } from "@/plugins/api/api";
const { Paths } = useApi();

export default /*#__PURE__*/_defineComponent({
  __name: 'AffiliationAutocomplete',
  props: {
    value: null,
    label: { default: "所属" },
    autoSelectFirst: { type: Boolean },
    init: { type: Boolean },
    path: { default: Paths.approval.affiliationall },
    code: { type: Boolean }
  },
  emits: ["input"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "input", val?: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value?: number, label: string, autoSelectFirst?: boolean, init?: boolean, path: string, code?: boolean };

const { $get } = useApi();




const items = ref<Shozoku[]>([]);

const modelValue = computed({
  get: () => props.value,
  set: val => emits("input", val)
});

const getAffiliationItems = async () => {
  const response = await $get<Shozoku[]>(props.path);
  if (response) items.value = response;
};

const convertText = (item: Shozoku) => {
  return props.code ? `${item.scode} ${item.sname}` : item.sname;
};

watch(
  () => props.path,
  async () => {
    await getAffiliationItems();
  }
);

watch(items, val => {
  const firstItem = val[0].incode;
  if (firstItem && !modelValue.value && props.init)
    modelValue.value = firstItem;
});

onMounted(async () => {
  await getAffiliationItems();
});

return { __sfc: true,Paths, $get, props, emits, items, modelValue, getAffiliationItems, convertText }
}

})